import { useEffect } from "react";

import { AppProviders } from "./providers";
import { AppRouter } from "./router";

const APP_DOCUMENT_TITLE = "Daaru Na'im 18th Annual International Conference 2027";

export function App() {
  useEffect(() => {
    document.title = APP_DOCUMENT_TITLE;
  }, []);

  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
